<template>
  <v-card
    tile
    :disabled="loading"
    hover
    :class="
      $vuetify.dark ? 'card-dark beez-card ma-1' : 'card-light beez-card ma-1'
    "
  >
    <v-flex xs12 @click.stop="setSelectedKey">
      <v-layout row fill-height wrap>
        <v-flex xs12 sm12 md4 class="pa-2">
          <div
            class="text-xs-left pl-4"
            v-if="selectedServiceHexId === item.hexId"
          >
            <div
              class="title font-weight-light"
              style="white-space:pre-line; word-break: break-all"
            >
              {{ item.name }}
            </div>
            <div class="body-2 text-truncate pt-1">
              {{ item.description }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      class="pl-4 pr-2"
      @click.stop="setSelectedKey"
      v-if="selectedServiceHexId !== item.hexId"
    >
      <v-layout justify-space-between row wrap>
        <v-flex xs12>
          <div class="text-xs-left">
            <div class="title font-weight-light text-truncate">
              {{ item.name }}
            </div>
            <div class="body-2 text-truncate pt-1">
              {{ item.description }}
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-card-actions>
      <v-spacer />
      <v-layout align-center justify-end row fill-height>
        <v-tooltip bottom>
          <v-btn
            class="px-2"
            slot="activator"
            flat
            icon
            large
            @click.stop="setSelectedKey"
          >
            <v-icon>
              {{
                selectedServiceHexId === item.hexId
                  ? 'keyboard_arrow_up'
                  : 'keyboard_arrow_down'
              }}
            </v-icon>
          </v-btn>
          <span>{{
            selectedServiceHexId === item.hexId
              ? 'Show few details'
              : 'Show more details'
          }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            class="px-2"
            slot="activator"
            flat
            icon
            large
            @click.stop="showServiceInfo = true"
          >
            <v-icon>info</v-icon>
          </v-btn>
          <span>Show Service information</span>
        </v-tooltip>
        <v-tooltip bottom>
          <service-runner
            class="px-2"
            slot="activator"
            :key="item.hexId"
            :automation="item"
            type="SelfService"
            ask-business-reason
            show-label
            full-screen
            @submit="refresh"
            v-if="can"
          />
          <span>Raise Automation Service request</span>
        </v-tooltip>
      </v-layout>
    </v-card-actions>
    <v-card
      v-if="selectedServiceHexId === item.hexId"
      class="pa-2"
      style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px"
    >
      <v-card flat>
        <v-layout class="row wrap">
          <v-flex xs12>
            <automation-request-history :service-hex-id="item.hexId" />
          </v-flex>
        </v-layout>
      </v-card>
    </v-card>

    <!--show a dialog with service informaion-->
    <v-dialog
      v-model="showServiceInfo"
      max-width="800px"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>
          <div class="headline">Service Information</div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout class="row wrap">
              <v-flex xs12>
                <div class="text-xs-left">
                  <div>Service description</div>
                  <br />
                </div>
                <div class="body-2 text-lg-left " v-html="compiledMD"></div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="text-capitalize"
            flat
            @click.native="showServiceInfo = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import AutomationRequestHistory from '@/components/self-service/AutomationRequestHistory'
import KpiCard from '@/components/common/KpiCard'
import ServiceRunner from '@/components/common/ServiceRunner'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import marked from 'marked'

export default {
  name: 'automation-service-card',
  components: { AutomationRequestHistory, KpiCard, ServiceRunner },
  props: {
    item: Object,
    selectedServiceHexId: String,
    loading: Boolean
  },
  data() {
    return {
      showServiceInfo: false,
      aboutService: 1,
      orderHistory: 0,
      tabService: null
    }
  },
  mounted() {
    this.initSelfServiceView()
  },
  methods: {
    refresh() {},
    initSelfServiceView() {
      if (
        (this.$router.currentRoute.name === 'service' ||
          this.$router.currentRoute.name === 'service-ar-history') &&
        this.item.hexId === this.$route.params.hexId
      ) {
        this.tabService = this.orderHistory
      } else if (
        this.$router.currentRoute.name === 'service-info' &&
        this.item.hexId === this.$route.params.hexId
      ) {
        this.tabService = this.aboutService
      }
    },
    setSelectedKey() {
      if (
        this.$router.currentRoute.name === 'home' ||
        this.item.hexId !== this.$route.params.hexId
      ) {
        this.$router
          .replace({
            name: 'service',
            params: { hexId: this.item.hexId }
          })
          .catch()
        this.$emit('selected-service', this.item.hexId)
      } else {
        this.$router.replace({ name: 'home' }).catch()
        this.$emit('selected-service', null)
      }
    }
  },
  computed: {
    ...mapGetters({
      can: 'can'
    }),
    gradient() {
      return [this.$vuetify.theme.secondary, this.$vuetify.theme.accent]
    },
    compiledMD() {
      if (this.item.documentation) {
        return marked(this.item.documentation)
      } else {
        return ''
      }
    }
  }
}
</script>
